export { default } from '@bottlebooks/gatsby-theme-base/src/components/Link/Link';
